import classNames from "classnames";
import { getImageUrl } from "src/helpers/helpers";
import fallbackProduct from "src/images/fallbackProduct.png";
import TextCell from "./TextCell";

const ImageTextCell = ({
  imageSrc,
  value,
  className,
}: {
  imageSrc: string;
  value: string | number;
  className?: string;
}) => {
  return (
    <div className={classNames("flex", className)}>
      <img
        src={imageSrc ? getImageUrl(imageSrc) : fallbackProduct}
        alt={value?.toString()}
        className="w-[30px] h-[30px] rounded-full"
      />
      <TextCell value={value} className="justify-center" />
    </div>
  );
};

export default ImageTextCell;
